<template>
    <v-app>

        <v-main>
            <vue-page-transition>
                <router-view></router-view>
            </vue-page-transition>
        </v-main>

        <v-fab-transition>
            <a href="tel:09365531427">
                <!--      <a href="tel:09926576813">-->

                <v-btn aria-label="Call Aylar Khani"
                        class="black--text mb-3 ml-3  mb-n1 ml-n1"
                        large
                        color="success"
                        elevation="0"
                        fab
                        fixed
                        bottom
                        left
                >
                    <i class="fa-solid fa-phone white--text font-26"></i>
                </v-btn>
            </a>
        </v-fab-transition>
<!--        <v-fab-transition>

            <v-btn
                    id="animateFab"
                    @click="top()"
                    class="animateFab mb-3 ml-3 "
                    large
                    color="primary"
                    elevation="0"
                    fab
                    fixed
                    bottom
                    right
            >
                <i class="fa-solid fa-angles-up white&#45;&#45;text font-20"></i>
            </v-btn>

        </v-fab-transition>-->

    </v-app>

</template>

<script>

export default {
    name: "App",
    components: {},
    data: () => ({
        //
    }),
    methods: {
        top() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
    }
};
</script>
